type FullFormatter = (
  value: string,
  prevValue: string,
  cursor: number,
  options: { isFocused: boolean }
) => { value: string; cursor: number };
type ShortFormatter = (
  value: string,
  prevValue: string,
  cursor: number,
  options: { isFocused: boolean }
) => string;

export type Formatter = FullFormatter | ShortFormatter;

export type Parser = (value: string) => string;

export const createInputFormatter = (fn: Formatter): Formatter => fn;
export const createInputParser = (fn: Parser): Parser => fn;
